import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { FabricSqlEndpointMetadataLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricSqlEndpointMetadataLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FabricSqlEndpointMetadataLinkedServiceAdapter extends LinkedServiceAdapter<FabricSqlEndpointMetadataLinkedService> {

    protected modelConstructor(): new () => FabricSqlEndpointMetadataLinkedService {
        return FabricSqlEndpointMetadataLinkedService;
    }

    protected model(): IModel {
        return FabricSqlEndpointMetadataLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: FabricSqlEndpointMetadataLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: FabricSqlEndpointMetadataLinkedService): Promise<FabricSqlEndpointMetadataLinkedService> {
        return linkedService;
    }
}